import { InputHTMLAttributes } from "react";

export const scales = {
  SM: "sm",
  MD: "md",
} as const;

export type Scales = typeof scales[keyof typeof scales];

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  scale?: Scales;
  children?: import('react').ReactNode;
}
